import { Card } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const OnboardingFallback = () => {
  return (
    <div className="pb-25">
      <Card className="py-0 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-[2fr_1fr]">
          <div className="p-6 lg:p-8 lg:border-r">
            <Skeleton className="h-8 w-64 mb-8" />
            <div className="space-y-6">
              <Skeleton className="h-6 w-40" />
              <Skeleton className="h-9 w-full" />
              <Skeleton className="h-9 w-full" />
              <Skeleton className="h-16 w-full" />
              <Skeleton className="h-6 w-40" />
              <Skeleton className="h-9 w-full" />
              <Skeleton className="h-9 w-full" />
              <Skeleton className="h-9 w-full" />
              <Skeleton className="h-9 w-full" />
              <Skeleton className="h-11 w-full" />
            </div>
          </div>
          <div className="hidden lg:block p-8">
            <Skeleton className="h-8 w-40 mb-8" />
            <div className="space-y-6">
              <Skeleton className="h-16 w-full" />
              <Skeleton className="h-16 w-full" />
              <Skeleton className="h-16 w-full" />
            </div>
          </div>
        </div>
      </Card>
    </div>
  )
}

export const BillingOnlyFallback = () => {
  return (
    <div className="pb-25">
      <Card className="py-0 overflow-hidden">
        <div className="p-6 lg:p-8">
          <Skeleton className="h-8 w-64 mb-3" />
          <Skeleton className="h-4 w-full max-w-xl mb-8" />
          <div className="space-y-6">
            <Skeleton className="h-9 w-full" />
            <Skeleton className="h-9 w-full" />
            <Skeleton className="h-9 w-full" />
            <Skeleton className="h-9 w-full" />
            <Skeleton className="h-11 w-full" />
          </div>
        </div>
      </Card>
    </div>
  )
}
